const INITIAL_STATE = {
    organization : 0
}
const organization = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADD':
            return {
                ...state,
                organization: action.payload,
            }
        default:
            return state;
    }
}

export default  organization;